import React, { Suspense } from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route } from "react-router-dom";

import store from "./components/store";
import Header from "./components/Header";
import SingleAnime from "./components/animeshowcase/SingleAnime";
import Home from "./components/Home";
import LoadingSpinner from "./components/LoadingSpinner";

import "./App.css";

const ShowCaseCategory = React.lazy(() =>
  import("./components/animeshowcase/ShowCaseCategory")
);
const ViewMoreContent = React.lazy(() =>
  import("./components/animeshowcase/ViewMoreContent")
);
const ShowCase = React.lazy(() =>
  import("./components/animeshowcase/ShowCase")
);
const AdvancedSearch = React.lazy(() =>
  import("./components/search mechanism/AdvancedSearch")
);

const App = () => {
  return (
    <Provider store={store}>
      <Router>
        <Header />
        <div className="main container">
          <Route path="/" exact component={Home} />
          <Suspense fallback={<LoadingSpinner asOverlay />}>
            <Route path="/category/:genre" exact component={ShowCaseCategory} />
            <Route path="/expanded/:title" exact component={ViewMoreContent} />
            <Route path="/manga/new" component={ShowCase} />
          </Suspense>
        </div>
        <Suspense fallback={<LoadingSpinner asOverlay />}>
          <Route path="/:slug/:id" exact component={SingleAnime} />
          <Route path="/advanced-search" component={AdvancedSearch} />
        </Suspense>
      </Router>
    </Provider>
  );
};

export default App;
